import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-last-reclamations-chart',
    templateUrl: './last-reclamations-chart.component.html',
    styleUrl: './last-reclamations-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LastReclamationsChartComponent {

}
